import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import { observer } from 'mobx-react';

const DealItem = observer( ({deal,myStores}) => (
	<div style={styles.dealItemContainer}>
		<div style={styles.dealItemMain}>
			<div className='text-center' style={{marginBottom: 10}}>
		      <img className='img-responsive center-block' src={deal.downloadURL} alt='Deal Image' />
		    </div>

		    <div style={styles.info}>

		      <div>
		        <p>{deal.vendor}</p>
		        <p>{"$" + Number(deal.price / 100).toFixed(2) || deal.percent + "%"} Off</p>

		       <p>
		         {deal.category.eat ? "Eat" : null}<span> | </span>
		         {deal.category.play ? "Play" : null}<span> | </span>
		         {deal.category.parents ? "Parents" : null}<span> | </span>
		       </p>

		       <p>Exp: { deal.expiration ? deal.expiration : null } </p>

		      </div>


		      <div style={{display: 'flex', flexDirection: 'column'}}>
		       <p style={{fontSize: "1.2em"}}>{deal.dealTitle}</p>

		       <Button
		       		variant='raised'
		       		color="primary"
		       		fontSize={20}
		       		onClick={()=> myStores.mainStore.forceListEvent(deal)}
		       >
		       Force List
		       </Button>

					 <Button
							variant='raised'
							color="secondary"
							onClick={()=> myStores.mainStore.deleteEvent(deal,'stagedEvents')}
					 >
					 Delete Event
					 </Button>

		       <br/>

		      </div>

		    </div>

		    <div>
		      <p> <b>Days:</b> </p>
						<p>
						{deal.days.any_day ? "Any Day \n" : null}
						</p>
						<p>
		        {deal.days.Monday ? "Monday \n" : null}
						</p>
						<p>
		        {deal.days.Tuesday ? "Tuesday\n" : null}
						</p>
						<p>
		        {deal.days.Wednesday ? "Wednesday\n" : null}
						</p>
						<p>
		        {deal.days.Thursday ? "Thursday\n" : null}
						</p>
						<p>
		        {deal.days.Friday ? "Friday\n" : null}
						</p>
						<p>
		        {deal.days.Saturday ? "Saturday\n" : null}
						</p>
						<p>
		        {deal.days.Sunday ? "Sunday\n" : null}
		        </p>

		        <p><b>Time:</b> </p>
							<p>
							{ deal.time.all_day ? "All Day\n" : null }
							</p>
							<p>
		          { deal.time.morning ? "Morning\n" : null }
							</p>
							<p>
		          { deal.time.afternoon ? "Afternoon\n" : null }
							</p>
							<p>
		          { deal.time.evening ? "Evening\n" : null }
							</p>
							<p>
		          { deal.time.custom_time ? deal.time.custom_time : null }
 							</p>

		        <p>
		        <b>Age Group:</b>
						</p>
							<p>
							{ deal.age.all_ages ? "All Ages\n" : null }
							</p>
							<p>
		          { deal.age.teens ? "Teens\n" : null }
							</p>
							<p>
		          { deal.age.pre_teens ? "Pre-Teens\n" : null }
							</p>
							<p>
		          { deal.age.toddlers ? "Toddlers\n" : null }
							</p>
							<p>
		          { deal.age.infants ? "Infants\n" : null }
							</p>

							<p>
		          { deal.age.zeroTwo ? "0-2 yrs. old\n" : null }
							</p>
							<p>
		          { deal.age.threeSix ? "3-6 yrs. old\n" : null }
							</p>
							<p>
		          { deal.age.sevenTen ? "7-10 yrs. old\n" : null }
							</p>
							<p>
		          { deal.age.elevenSeventeen ? "11-17 yrs. old\n" : null }
							</p>
							<p>
		          { deal.age.eighteenPlus ? "18+ yrs. old\n" : null }
							</p>

		      <p><b>List Date:</b> { deal.list_date ? deal.list_date : null }</p>
		      <p><b>Start Date:</b> { deal.start_date ? deal.start_date : null }</p>
		      <p><b>Expiration Date:</b> { deal.expiration ? deal.expiration : null } </p>
		      <p>
		      <b>Description:</b> {deal.description}
		      </p>
		    </div>
		</div>
	</div>
))

const DealsStaged = observer( class DealsStaged extends Component {

	constructor() {
		super()
		this.state = {
			deals: null
		}
		this.approveDeal = this.approveDeal.bind(this)
		this.removeDealFromStaged = this.removeDealFromStaged.bind(this)
	}

	componentDidMount(){
	}


	approveDeal(deal){
		let mongo = process.env.REACT_APP_MONGO
		let deals = "https://api.mlab.com/api/1/databases/funily/collections/deals?apiKey="+ mongo;

		let editDate = new Date().toUTCString();
		deal.note = "Deal was force listed on " + editDate;
		deal.force_list_date = editDate;

		//  send edited deal to deals database
		fetch(deals,{
	        method: "POST",
	        headers:{
	          Accept: 'application/json',
	          'Content-Type': 'application/json'
	        },
	        body: JSON.stringify(deal)
	      }).then(function(res){

	        if(res.status == 200){

	        	//  remove the deal from edited
	        	this.removeDealFromStaged(deal)

	        } else {

	        	console.log('response status is not ok',res);

	        }


	      }.bind(this))
	        .catch(err => console.log('error saving deal to mongo',err))


	}

	removeDealFromStaged(deal) {
		let mongo = process.env.REACT_APP_MONGO;
		let backup = "https://api.mlab.com/api/1/databases/funily/collections/backup?apiKey="+ mongo;
		let runCommand = "https://api.mlab.com/api/1/databases/funily/runCommand?apiKey="+mongo;

		// make a copy before removing
		fetch(backup,{
			method: "POST",
	        headers:{
	          Accept: 'application/json',
	          'Content-Type': 'application/json'
	        },
	        body: JSON.stringify(deal)
		})
		.then(res => {

			if(res.status == 200){
				console.log('backup was created, removing deal from staged...');

				// remove from edited
				let remove = {
					findAndModify: 'staged',
					query: {_id: {"$oid": deal._id.$oid}},
					remove: true
				}
				fetch(runCommand,{
					method: "POST",
			        headers:{
			          Accept: 'application/json',
			          'Content-Type': 'application/json'
			        },
			        body: JSON.stringify(remove)
				})
				.then(res => {
					if(res.status == 200){
						console.log('deal was removed from staged')
						this.refresh()
					} else {
						console.log('deal was not removed from staged');
					}
				})
				.catch(err => console.log('error removing deal from staged', err))

			} else {
				console.log('status was not 200 in removing deal from staged');
			}

		})
		.catch(err => console.log('error creating deal backup', err));

	}

	render() {
		let { mainStore } = this.props.myStores;
		return (
			<div style={styles.container}>
				<h1 className='text-center' style={styles.heading}>Staged Deals</h1>
				{
					mainStore.preListings.stagedEvents ?
					mainStore.preListings.stagedEvents.slice().map(item => {
						return <DealItem
											{ ...this.props }
											deal={item}
											key={item.deal_code}
									/>
					})
					: null
				}
			</div>
		);
	}

})


const styles = {
	container: {
		marginTop: '25vh'
	},
	heading: {
		color: '#3748ac'
	},
	dealItemContainer: {
		display: 'flex',
		justifyContent: 'center'
	},
	dealItemMain: {
		border: '1px solid #3748ac',
	    display: 'flex',
	    flexDirection: 'column',
	    justifyContent: 'center',
	    paddingRight: 30,
	    paddingLeft: 30,
	    paddingTop: 10,
	    paddingBottom: 10,
	    width: "50%",
	    boxShadow: '5px 10px 10px #3748ac',
	    marginTop: '2vh'
	},
	info: {
	    display: 'flex',
	    justifyContent: 'space-between'
	}
}

export default DealsStaged



// WEBPACK FOOTER //
// ./src/components/admin/DealsStaged.js